import api from "../api/axios";
import { PaginatedResponse } from "../Types/Common/PaginatedResponse";
import { ViewEmployee } from "../Types/Workforce/201File";

export const VIEW_EMPLOYEE_QUERY_KEY = ["view-employee"];

export const Employee201FileService = {
  getAllEmployee: async (
    page: number = 1,
    perPage: number = 10,
    search: string = "",
  ): Promise<PaginatedResponse<ViewEmployee>> => {
    const response = await api.get(`api/view-employee`, {
      params: {
        page,
        per_page: perPage,
        search,
      },
    });

    return response.data;
  },
  getEmployeeById: async (emp_no: string) => {
    const response = await api.get(`api/view-employee/${emp_no}`);
    return response.data;
  },
};
